<slotcom-navigation-button
  type="close"
  (click)="closeRankingModal()">
</slotcom-navigation-button>

<slotcom-navigation-button
  type="info"
  (click)="openRankingInfo()">
</slotcom-navigation-button>

<div
  class="ranking-modal-container"
  theming
  themingGroup="portal"
  themingAsset="ranking-background">
  <slotcom-wallet
    [type]="'Coins'"
    [animate]="true"></slotcom-wallet>
  <div class="ranking-modal-content">
    <div class="ranking-banner-container">
      <div
        class="ranking-icon"
        theming
        themingGroup="portal"
        themingAsset="ranking-logo"></div>

      <div class="ranking-general-info">
        <div class="text-container">
          @if (activeTab() === 0) {
            <div>
              <slotcom-p
                [bold]="true"
                [text]="'home.ranking.tabs.general.message' | translate"
                [fontSize]="1.45"
                [shadowBorder]="true"></slotcom-p>
            </div>
          }
          @if (activeTab() === 1) {
            <div>
              <slotcom-p
                [bold]="true"
                [text]="'home.ranking.tabs.friends.message' | translate"
                [fontSize]="1.45"
                [shadowBorder]="true"></slotcom-p>
            </div>
          }
          @if (activeTab() === 2) {
            <div>
              <slotcom-p
                [bold]="true"
                [text]="'home.ranking.tabs.king.message' | translate"
                [fontSize]="1.45"
                [shadowBorder]="true"></slotcom-p>
            </div>
          }
        </div>
      </div>
      @if (rankingEnabled()) {
        <slotcom-ranking-prize [isAwardPending]="isAwardPending()"></slotcom-ranking-prize>
      }
    </div>
    @if (rankingEnabled()) {
      <div class="ranking-tabs-container">
        <div class="c-ranking-tabs">
          <div class="c-ranking-tabs__header">
            <button
              type="button"
              class="c-ranking-tabs__tab"
              [class.c-ranking-tabs__tab--active]="activeTab() === 0"
              (click)="setTab(0)">
              <span class="c-ranking-tabs__label">{{ 'home.ranking.tabs.general.title' | translate | uppercase }}</span>
            </button>
            <button
              type="button"
              class="c-ranking-tabs__tab"
              [class.c-ranking-tabs__tab--active]="activeTab() === 1"
              (click)="setTab(1)">
              <span class="c-ranking-tabs__label">{{ 'home.ranking.tabs.friends.title' | translate | uppercase }}</span>
            </button>
            <button
              type="button"
              class="c-ranking-tabs__tab"
              [class.c-ranking-tabs__tab--active]="activeTab() === 2"
              (click)="setTab(2)">
              <span class="c-ranking-tabs__label">{{ 'home.ranking.tabs.king.title' | translate | uppercase }}</span>
            </button>
          </div>
          <div
            class="c-ranking-tabs__panel"
            [hidden]="activeTab() !== 0">
            @if (topRanking(); as generalRankings) {
              <div>
                @if (generalRankings.length == 0) {
                  <div class="text-container">
                    <slotcom-p
                      [bold]="true"
                      class="padded-number"
                      [text]="'home.ranking.tabs.general.empty' | translate"
                      [fontSize]="1.3"
                      [shadowBorder]="true"></slotcom-p>
                  </div>
                }
                <slotcom-ranking-list
                  class="ranking-item-list"
                  [rankings]="generalRankings"></slotcom-ranking-list>
              </div>
            }
            @if (myCurrentRanking(); as self) {
              <div class="your-position">
                @if (self !== undefined && self.rankingPosition > 10) {
                  <slotcom-ranking-item [ranking]="self"></slotcom-ranking-item>
                }
              </div>
            }
          </div>
          <div
            class="c-ranking-tabs__panel"
            [hidden]="activeTab() !== 1">
            @if (friendsRanking(); as friendsRankings) {
              <div>
                @if (friendsRankings.length == 0) {
                  <div class="text-container">
                    <slotcom-p
                      [bold]="true"
                      class="padded-number"
                      [text]="'home.ranking.tabs.general.empty' | translate"
                      [fontSize]="1.3"
                      [shadowBorder]="true"></slotcom-p>
                  </div>
                }
                <slotcom-ranking-list
                  class="ranking-item-list"
                  [rankings]="friendsRankings"
                  [isFriends]="true"
                  [showMedals]="false"
                  [hideReward]="true"></slotcom-ranking-list>
              </div>
            }
          </div>
          <div
            class="c-ranking-tabs__panel"
            [hidden]="activeTab() !== 2">
            @if (lastKingRanking(); as kingRankings) {
              <div>
                <div class="ranking-king-tab">
                  <div class="king-flag">
                    <slotcom-p
                      [bold]="true"
                      class="flag-label"
                      [text]="('home.ranking.tabs.king.flag' | translate) + endDateStr()"
                      [fontSize]="1.3"
                      [shadowBorder]="true"></slotcom-p>
                  </div>
                  <div class="king-crown"></div>
                  <div
                    class="first-king-container"
                    [ngClass]="firstThroneSelf() ? 'self-throne' : 'other-throne'">
                    <div class="king-medal first"></div>
                    <div class="king-user-info">
                      <div class="king-avatar">
                        @if (kingRankings.length > 0) {
                          <slotcom-avatar [userId]="kingRankings[0].userId"></slotcom-avatar>
                        }
                      </div>
                      <div class="king-username">
                        @if (kingRankings.length > 0) {
                          <slotcom-p
                            [bold]="true"
                            [text]="kingRankings[0].nickName"
                            [fontSize]="1.5"
                            [shadowBorder]="true"></slotcom-p>
                        }
                      </div>
                      <div class="king-points">
                        @if (kingRankings.length > 0) {
                          <slotcom-p
                            [bold]="true"
                            [text]="
                              kingRankings[0].rankingScore | number: '1.0-0' : ('common.culture' | translate)
                            "></slotcom-p>
                        }
                      </div>
                      <div class="king-reward">
                        <div class="ranking-reward-display">
                          <div class="present-img"></div>
                          @if (kingRankings.length > 0) {
                            <slotcom-p
                              [bold]="true"
                              class="reward-text"
                              [text]="
                                kingRankings[0].prize.credits | number: '1.0-0' : ('common.culture' | translate)
                              "></slotcom-p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="second-king-container"
                    [ngClass]="secondThroneSelf() ? 'self-throne' : 'other-throne'">
                    <div class="king-medal second"></div>
                    <div class="king-user-info">
                      <div class="king-avatar">
                        @if (kingRankings.length > 1) {
                          <slotcom-avatar [userId]="kingRankings[1].userId"></slotcom-avatar>
                        }
                      </div>
                      <div class="king-username">
                        @if (kingRankings.length > 1) {
                          <slotcom-p
                            [bold]="true"
                            [text]="kingRankings[1].nickName"
                            [fontSize]="1.5"
                            [shadowBorder]="true"></slotcom-p>
                        }
                      </div>
                      <div class="king-points">
                        @if (kingRankings.length > 1) {
                          <slotcom-p
                            [bold]="true"
                            [text]="
                              kingRankings[1].rankingScore | number: '1.0-0' : ('common.culture' | translate)
                            "></slotcom-p>
                        }
                      </div>
                      <div class="king-reward">
                        <div class="ranking-reward-display">
                          <div class="present-img"></div>
                          @if (kingRankings.length > 1) {
                            <slotcom-p
                              [bold]="true"
                              class="reward-text"
                              [text]="
                                kingRankings[1].prize.credits | number: '1.0-0' : ('common.culture' | translate)
                              "></slotcom-p>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="third-king-container"
                    [ngClass]="thirdThroneSelf() ? 'self-throne' : 'other-throne'">
                    <div class="king-medal third"></div>
                    <div class="king-user-info">
                      <div class="king-avatar">
                        @if (kingRankings.length > 2) {
                          <slotcom-avatar [userId]="kingRankings[2].userId"></slotcom-avatar>
                        }
                      </div>
                      <div class="king-username">
                        @if (kingRankings.length > 2) {
                          <slotcom-p
                            [bold]="true"
                            [text]="kingRankings[2].nickName"
                            [fontSize]="1.5"
                            [shadowBorder]="true"></slotcom-p>
                        }
                      </div>
                      <div class="king-points">
                        @if (kingRankings.length > 2) {
                          <slotcom-p
                            [bold]="true"
                            [text]="
                              kingRankings[2].rankingScore | number: '1.0-0' : ('common.culture' | translate)
                            "></slotcom-p>
                        }
                      </div>
                      <div class="king-reward">
                        <div class="ranking-reward">
                          <div class="ranking-reward-display">
                            <div class="present-img"></div>
                            @if (kingRankings.length > 2) {
                              <slotcom-p
                                [bold]="true"
                                class="reward-text"
                                [text]="
                                  kingRankings[2].prize.credits | number: '1.0-0' : ('common.culture' | translate)
                                "></slotcom-p>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (myLastRanking(); as self) {
              <div class="your-position king">
                @if (self !== undefined && self.rankingPosition > 3) {
                  <slotcom-ranking-item [ranking]="self"></slotcom-ranking-item>
                }
              </div>
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="ranking-tabs-container-disabled">
        <slotcom-p
          [bold]="true"
          class="reward-text"
          [text]="'home.ranking.disabled.title' | translate | uppercase"></slotcom-p>
        <slotcom-p
          [bold]="true"
          class="reward-text"
          [text]="'home.ranking.disabled.message' | translate"></slotcom-p>
      </div>
    }
  </div>
</div>
